export const PURPLE_GRADIENT_CATEGORY_NAMES = ['Dyson']

export const GOLD_GRADIENT_CATEGORY_NAMES = ['iPhone 18']

export const BORDER_RIGHT_CATEGORY_NAMES = ['Аксессуары']
